import React from 'react'

import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Trans, useTranslation } from 'react-i18next'

import { Hug, Text } from '@cash-design-system/react'
import { Region, regionConfig } from '@cash-web/shared-data-access-region-provider'

const ChameleonLink = styled.a`
  color: inherit;
`

const Link = ({ children, link, ariaLabel }: React.PropsWithChildren<{ link: string; ariaLabel: string }>) => (
  <Text typography="linkS" color="textProminent">
    <ChameleonLink href={link} target="_blank" rel="noreferrer" aria-label={ariaLabel}>
      {children}
    </ChameleonLink>
  </Text>
)

export function LegalText({ region = 'US' }: { region: Region }) {
  const theme = useTheme()
  const { t } = useTranslation()

  const {
    links: { terms, eSignConsent, privacyPolicy },
  } = regionConfig[region]

  return (
    <Hug maxWidth={theme.maxWidths.content}>
      <Text typography="bodyS" color="textSubtle">
        <Trans
          i18nKey={
            'By entering and clicking Continue, you agree to the <Terms>Terms</Terms>, <EsignConsent>E-Sign Consent</EsignConsent>, & <PrivacyPolicy>Privacy Policy</PrivacyPolicy>.'
          }
          context="Footer text. Links to terms of service, e-sign consent, and privacy policy."
          components={{
            Terms: (
              <Link
                link={terms}
                key={terms}
                ariaLabel={t('URL link to terms of service.', { context: 'Terms of service link' })}
              />
            ),
            EsignConsent: (
              <Link
                link={eSignConsent}
                key={eSignConsent}
                ariaLabel={t('URL link to e-sign consent.', { context: 'e-sign consent link' })}
              />
            ),
            PrivacyPolicy: (
              <Link
                link={privacyPolicy}
                key={privacyPolicy}
                ariaLabel={t('URL link to privacy policy.', { context: 'Privacy policy link' })}
              />
            ),
          }}
        />
      </Text>
    </Hug>
  )
}
